import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import ReportLog from './lib/log'
import App from './App.vue'
import router from './router'
import store from './store'
import { setAuth } from './lib/storage'
import '@/lib/antd'
// import '@/lib/cube-ui'
import Cube, { Locale } from 'cube-ui'
import '@/lib/utils' // 公共方法挂载到 vue 的原型上
import { isMobile } from '@/lib/device'
import eventBus from '@/lib/eventBus'
import cn from '@/lib/zh-cn'
import xss from 'xss'
import moment from 'moment'
import 'moment/locale/zh-cn'
import Cookies from 'js-cookie'
import Draggable from 'vuedraggable'
import i18n from '@/lib/language'
import { getLang } from '@/lib/storage'
import enUSMessages from '@/lib/cube-en-US'
import {
  getUaType,
  beforeLoginWhiteListPath,
  afterLoginBlackListPath,
  uaTypeLandingAuthorization
} from '@/lib/before-router'
import VueClipboard from 'vue-clipboard2'
// import Vconsole from 'vconsole'
Es6Promise.polyfill()
// import Vconsole from 'vconsole'
// process.env.NODE_ENV && new Vconsole()
// process.env.NODE_ENV === 'development' && new Vconsole()
/* import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
Sentry.init({
  dsn: 'http://501ed2a32a0646e29a1ca6e2eccbf51a@192.168.8.141:9000/3',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  logErrors: true,
  release: process.env.RELEASE_VERSION // 版本号
}) */
let xssOptions = {
  // 默认白名单参考 xss.whiteList
  whiteList: {
    a: ['target', 'href', 'title', 'style', 'class'],
    audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
    b: ['style', 'class'],
    blockquote: ['cite'],
    br: [],
    center: ['style', 'class'],
    dd: ['style', 'class'],
    div: ['style', 'class'],
    dl: ['style', 'class'],
    dt: ['style', 'class'],
    em: ['style', 'class'],
    font: ['color', 'size', 'face'],
    footer: ['style', 'class'],
    h1: ['style', 'class'],
    h2: ['style', 'class'],
    h3: ['style', 'class'],
    h4: ['style', 'class'],
    h5: ['style', 'class'],
    h6: ['style', 'class'],
    header: ['style', 'class'],
    hr: [],
    i: ['style', 'class'],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: ['style', 'class'],
    ol: ['style', 'class'],
    p: ['style', 'class'],
    pre: [],
    s: [],
    span: ['style', 'class'],
    strong: ['style', 'class'],
    table: ['width', 'border', 'align', 'valign', 'style'],
    tbody: ['align', 'valign'],
    td: ['width', 'rowspan', 'colspan', 'align', 'valign', 'style'],
    tfoot: ['align', 'valign'],
    th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
    thead: ['align', 'valign'],
    tr: ['rowspan', 'align', 'valign'],
    tt: [],
    u: ['style', 'class'],
    ul: ['style', 'class'],
    video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width']
  },
  stripIgnoreTag: true, // true：去掉不在白名单上的标签
  stripIgnoreTagBody: ['script', 'style', 'br'], // ['tag1', 'tag2']：仅去掉指定的不在白名单上的标签

  onTagAttr: function () {
    // todo
  }
}
const filterXss = new xss.FilterXSS(xssOptions)

let sentry = ReportLog.getInstance(Vue, {})
const isDingDing = window.location.hostname.indexOf('dtwork') > -1
Vue.prototype.$sentry = sentry // 设置全局变量
window.$sentry = sentry
Vue.prototype.$isDingDing = isDingDing
Vue.prototype.$xssOptions = xssOptions
Vue.prototype.$filterXss = filterXss

moment.locale('zh-cn', cn)

Vue.use(Cube)
Vue.use(Draggable)
Vue.use(i18n)
Vue.use(Locale)
Vue.use(xss, xssOptions)

const lang = getLang()
if (lang === 'en') {
  Locale.use('en-US', enUSMessages)
} else {
  Locale.use('zh-CN')
}
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$bus = eventBus
Vue.prototype.$moment = moment
Vue.prototype.$xss = xss

const uaType = getUaType()
const dingding = Vue.prototype.$getQueryString('referrer')
store.commit('setDingding', dingding)
// console.log(uaType)
if (isDingDing && uaType === 'isDingTalk' && (Cookies.get('dingTalk') !== 'dingding')) {
  setAuth('')
  store.commit('setAuth', '')
}
if (uaType === 'isWxWork') {
  store.commit('setQwWork', 'isWxWork')
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (isDingDing && (uaType !== 'isDingTalk')) {
    if (to.fullPath === '/account/normaltip') {
      next()
    } else {
      next('/account/normaltip')
    }
  } else {
    if (store.state.auth) {
      // ------------- 已登录 -------------
      // 如果已经登录，却尝试访问登录等页面，将继续保持原本的页面
      if (afterLoginBlackListPath.includes(to.path)) {
        next(from.path || '/')
      } else if (isMobile && to.name === 'InqueryPassDetail') {
        // 如果pc进入询盘通过详情,然后链接用移动端打开
        next({ ...to, name: 'InqueryDetail' })
      } else {
        // alert(34)
        sentry.setUser(store.state.auth, store.state.baseinfo)
        next()
      }
    } else {
      // ------------- 未登录 -------------
      if (beforeLoginWhiteListPath.includes(to.path)) {
        next()
      } else if (to.path === '/account/setuser') {
        if (from.path === '/account/register') {
          next()
        } else {
          next('/account/register')
        }
      } else if (uaType) { // 自动登陆授权
        uaTypeLandingAuthorization()
      } else {
        // 如果未登录，跳转到登录页面
        if (!store.state.auth) {
          next('/account/login')
        } else {
          next()
        }
      }
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
